<template>
	<CurvesPage class="curve" @onScale="drawLine">
		
		<!-- Название кривой -->
		
		<template #curveName>Улитка Паскаля</template>
		
		<!-- модуль Характеристика кривой -->
		
		<template #curveFeature>
		<!-- Геометрическое место точек -->
			
			<h5 class="mt-0">
				Геометрическое место точек:
			</h5>
			<img src="@/assets/img/LimaconPascal_gmt.gif" class="feature__gmt">
			<p class="feature__gmt">
				<strong>Улитка Паскаля</strong>
				- плоская алгебраическая кривая 4-го порядка. Ее можно определить как геометрическое место точек <vue-mathjax :formula="viewExpression('M, M1')" class="formula"></vue-mathjax>, 
				расположенных на прямых пучка с центром в точке <vue-mathjax :formula="viewExpression('O')" class="formula"></vue-mathjax>, лежащей на данной окружности радиуса
				 <vue-mathjax :formula="viewExpression('R')" class="formula"></vue-mathjax>, и находящихся на равном расстоянии  <vue-mathjax :formula="viewExpression('a')" class="formula"></vue-mathjax>
				 по обе стороны от точки пересечения  <vue-mathjax :formula="viewExpression('P')" class="formula"></vue-mathjax> прямых пучка с окружностью, где 
				<vue-mathjax :formula="viewExpression('a<2R')" class="formula"></vue-mathjax>. Улитка Паскаля изображена на нем красной линией.

			
			<!-- Уравнение в полярных координатах -->
			
			<h5 class="mt-0">
				Уравнение:
				<b-badge variant="light" class="curve__main-formula">
					<vue-mathjax
							:formula="equationInPolar"
							class="formula"
					></vue-mathjax>
				</b-badge>
			</h5>
			
			<!-- Уравнение в декартовых координатах -->
			
			<h5>Уравнение в декартовых координатах:</h5>
			<p>
				<vue-mathjax
						:formula="equationInCartesian" class="formula"></vue-mathjax>
			</p>
			
			<h5>Параметрическое уравнение:</h5>
			<p>
				<vue-mathjax
						:formula="equationParamInCartesian" class="formula"></vue-mathjax>
			</p>
			
			<!-- Область значений для параметра -->
			
			<h5 class="mt-0">Область значений <vue-mathjax :formula="parameterT" class="formula"></vue-mathjax>:</h5>
			
			<!--<b-form-input @input="drawLine" max="2" min="0" step="0.1" type="range" v-model="maxThetaControl"></b-form-input>-->
			<vue-slider
					v-model="t"
					:min="0"
					:max="2"
					:interval="0.1"
					@dragging="drawLine"
			></vue-slider>
			
			<p>
				<vue-mathjax :formula="rangeODZ" class="formula"></vue-mathjax>
			</p>
			
			<!-- Значения коэффициентов -->
			
			<h5>Зависимость от коэффициентов:</h5>
			
			<!-- Коэффициент a -->
			
			<label>
				<vue-mathjax :formula="coefficientA" class="formula"></vue-mathjax>:
			</label>
			
			<b-form-spinbutton v-model="a" min="-100" max="100" @input="drawLine" vertical class="curve__coef"></b-form-spinbutton>
			
			<!-- Коэффициент b -->
			
			<label>
				<vue-mathjax :formula="coefficientB" class="formula"></vue-mathjax>:
			</label>
			
			<b-form-spinbutton v-model="b" min="-100" max="100" vertical @input="drawLine" class="curve__coef"></b-form-spinbutton>
			
			<p v-if="(b !== 0) && (a !== 0) && (2 * a === b)">Этот частный случай называют <i>Кардиоидой</i>. <br><a href="/cardioid">Изучить подробнее...</a></p>
		
		</template>
		
		<!-- модуль Информация о кривой -->
		
		<!-- Изображение для модуля информации -->
		
		<template #curvePhoto>
			<a href="https://upload.wikimedia.org/wikipedia/commons/7/79/Blaise_pascal.jpg"><img src="@/assets/img/Blaise_pascal.jpg" width="100" alt="Блез Паскаль"></a>

		</template>
		
		<!-- Контент -->
	
		
		<template #curveInfo>
			<h5 class="mt-0">История</h5>
			<p>
				Своё название кривая получила в честь отца известного французского математика и физика <i><b>Блеза Паскаля</b></i> (1623-1662) - <i><b>Этьена Паскаля</b></i> 
				(председателя налогового управления г. Клермон-Ферран, любителя математики), который впервые описал эту кривую. 
			</p>
			
			<p>
				
			</p>
		</template>
		
		<!-- модуль Задачи -->
		
		<template #curveTasks>
			<h5 class="mt-0">Примеры задач:</h5>
		</template>
	
	</CurvesPage>
</template>

<script>
	import CurvesPage, { CurvesInterface } from '@/views/templates/CurvesPage';
	
	export default {
		name: 'LimaconPascal',
		mixins: [CurvesInterface],
		data () {
			return {
				/* Коэффициенты уравнения */
				a: 0,
				b: 0,
				/* ОДЗ параметра */
				t: [0, 2]
			}
		},
		computed: {
			/* Функции для представления в latex
			 * rangeODZ - ОДЗ параметра
			 * equationInPolar - Уравнение в полярных координатах
			 * equationInCartesian - Уравнение в декартовых координатах
			 * equationParamInCartesian - Параметрическое уравнение
			  * */
			rangeODZ: (context) => {
				return '$$ ' + context.t[0] +  '\\pi < t <' + context.t[1] + '\\pi $$';
			},
			equationInPolar: () => {
				return '$$r= 2a\\cos \\theta + b$$';
			},
			equationInCartesian: () => {
				return '$$ (x^{2} + y^{2} + 2ax)^{2} = b^{2}(x^{2} + y^{2}) $$';
			},
			equationParamInCartesian: () => {
				return '$$\\begin{cases}x=2a\\cos^{2} t + b \\cos t \\\\ y=a\\sin 2 t + b\\sin t \\end{cases}$$';
			},
			/* Свойство ОДЗ */
			maxTheta: ({ t }) => {
				return t[1] * Math.PI;
			},
			minTheta: ({ t }) => {
				return t[0] * Math.PI;
			}
		},
		methods: {
			/**
			 * Возвращает значение x при заданном параметре
			 * @param {number} t
			 * @return {number}
			 */
			X (t) {
				return 160 + (2 * this.a * Math.pow(Math.cos(t), 2) + this.b * Math.cos(t)) * this.$store.state.step;
			},
			/**
			 * Возвращает значение y при заданном параметре
			 * @param {number} t
			 * @return {number}
			 */
			Y (t) {
				return 160 - (this.a * Math.sin(2 * t) + this.b * Math.sin(t)) * this.$store.state.step;
			}
		},
		components: {
			CurvesPage
		}
	}
</script>

<style scoped lang="scss">

</style>
